import { useState, useEffect } from 'react'

import Api from 'services/api'

const useDeviceState = (deviceId, date) => {
  const [deviceState, setDeviceState] = useState(null)
  const [areDeviceStateLoaded, setAreDeviceStateLoaded] = useState(false)

  useEffect(() => {
    setDeviceState(null)
    setAreDeviceStateLoaded(false)

    Api.DeviceAggregator.getDeviceState(deviceId, date)
      .then((res) => {
        if (res) {
          setAreDeviceStateLoaded(true)
          setDeviceState(res)
        }
      })
      .catch(() => {
        setAreDeviceStateLoaded(true)
      })
  }, [deviceId, date])

  return { deviceState, areDeviceStateLoaded }
}

export default useDeviceState
